export const GRAFANA_PREFIX = 'packages.code_activation_triggers';
